import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const retailerModule = () => import('./retailers.module').then((m) => m.RetailersModule);

export const retailerRoutes: Routes = [
  {
    path: 'retailer',
    canActivateChild: [RoleGuard],
    loadChildren: retailerModule,
    data: {
      enum: 'RETAILER',
      label: 'Retailer',
      icon: 'ic_retailer.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'LIST_RETAILER_MENUNGGU',
          label: 'Terverifikasi',
          path: 'retailer/terverifikasi/active',
          children: [],
        },
        {
          enum: 'LIST_RETAILER_MENUNGGU',
          label: 'Sedang Menunggu',
          path: 'retailer/pending/register',
          children: [],
        },
        {
          enum: 'LIST_RETAILER_DITOLAK',
          label: 'Ditolak',
          path: 'retailer/reject',
          children: [],
        },
      ],
    },
  },
];
